var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59389 7.49454H13.0775C13.4885 7.49454 13.8248 7.15827 13.8248 6.74727C13.8248 6.33627 13.4885 6 13.0775 6H8.59389C8.18289 6 7.84662 6.33627 7.84662 6.74727C7.84662 7.15827 8.18289 7.49454 8.59389 7.49454Z",
    fill: "#6FCAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11037 9.73631H13.0776C13.4886 9.73631 13.8249 9.40004 13.8249 8.98904C13.8249 8.57805 13.4886 8.24178 13.0776 8.24178H4.11037C3.69937 8.24178 3.3631 8.57805 3.3631 8.98904C3.3631 9.40004 3.69937 9.73631 4.11037 9.73631Z",
    fill: "#6FCAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86739 11.9782H10.8346C11.2456 11.9782 11.5819 11.6419 11.5819 11.2309C11.5819 10.8199 11.2456 10.4836 10.8346 10.4836H1.86739C1.45639 10.4836 1.12012 10.8199 1.12012 11.2309C1.12012 11.6419 1.45639 11.9782 1.86739 11.9782Z",
    fill: "#6FCAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9126 13.4726C23.9126 13.0616 23.5763 12.7253 23.1654 12.7253H0.747269C0.336271 12.7253 0 13.0616 0 13.4726C0 13.8836 0.336271 14.2199 0.747269 14.2199H23.1654C23.5763 14.2199 23.9126 13.8836 23.9126 13.4726Z",
    fill: "#6FCAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1646 14.9673H1.86739C1.45639 14.9673 1.12012 15.3036 1.12012 15.7146C1.12012 16.1256 1.45639 16.4618 1.86739 16.4618H23.1646C23.5756 16.4618 23.9118 16.1256 23.9118 15.7146C23.9118 15.3036 23.5756 14.9673 23.1646 14.9673Z",
    fill: "#6FCAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59398 17.2091H4.11037C3.69937 17.2091 3.3631 17.5416 3.3631 17.9563C3.3631 18.3711 3.69937 18.7036 4.11037 18.7036H8.59398C9.00498 18.7036 9.34125 18.3711 9.34125 17.9563C9.34125 17.5416 9.00498 17.2091 8.59398 17.2091Z",
    fill: "#6FCAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6924 9.73631H18.6815C19.0925 9.73631 19.4287 9.40004 19.4287 8.98904C19.4287 8.57805 19.0925 8.24178 18.6815 8.24178H15.6924C15.2814 8.24178 14.9451 8.57805 14.9451 8.98904C14.9451 9.40004 15.2814 9.73631 15.6924 9.73631Z",
    fill: "#6FCAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3293 11.2308C12.3293 11.6418 12.6656 11.9781 13.0766 11.9781H20.9229C21.3339 11.9781 21.6702 11.6418 21.6702 11.2308C21.6702 10.8198 21.3339 10.4835 20.9229 10.4835H13.0766C12.6656 10.4835 12.3293 10.8198 12.3293 11.2308Z",
    fill: "#6FCAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9243 17.209H10.8361C10.4251 17.209 10.0889 17.5453 10.0889 17.9563C10.0889 18.3673 10.4251 18.7035 10.8361 18.7035H20.9243C21.3353 18.7035 21.6715 18.3673 21.6715 17.9563C21.6715 17.5453 21.3353 17.209 20.9243 17.209Z",
    fill: "#6FCAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFog);
export default __webpack_public_path__ + "static/media/fog.70c6c21cdf46bea00e358c6c8d1051eb.svg";
export { ForwardRef as ReactComponent };